// extracted by mini-css-extract-plugin
module.exports =  {"error-text":"template_editor__error-text___rfgOu","errorText":"template_editor__error-text___rfgOu"};